import { setMsalReadyPromise } from './api/tokenProvider.ts';
import { AuthenticationResult, EventType } from '@azure/msal-browser';
import { msalInstance } from './utils/msalInstance';

const msalReady = msalInstance.initialize();
setMsalReadyPromise(msalReady);

// Now import the rest of your app
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';
import App from './components/app/App/App.js';
import './index.css';
import { HelmetProvider } from 'react-helmet-async';

async function main() {
    await msalReady;

    // Default to using the first account if no account is active on page load
    if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
        const firstAccount = msalInstance.getAllAccounts()[0];
        if (firstAccount) {
            msalInstance.setActiveAccount(firstAccount);
        }
    }

    // Listen for sign-in event and set active account
    msalInstance.addEventCallback((event) => {
        if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
            const account = (event.payload as AuthenticationResult).account;
            msalInstance.setActiveAccount(account);
        }
    });

    const root = ReactDOM.createRoot(document.getElementById('root')!);

    root.render(
        <BrowserRouter>
            <MsalProvider instance={msalInstance}>
                <HelmetProvider>
                    <App />
                </HelmetProvider>
            </MsalProvider>
        </BrowserRouter>
    );
}

main();